var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeepcleaning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.621,
    height: 115.895,
    viewBox: "0 0 77.621 115.895",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1cd69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05ace2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M42.33,66.053,11.548,8.161a2.868,2.868,0,0,1,5.064-2.693L47.394,63.361l4.366-2.321a11.472,11.472,0,0,1,15.515,4.743l1.858,3.495,19.7,28.836L47.968,119.841,35.078,87.382l-1.857-3.493a11.472,11.472,0,0,1,4.743-15.514Zm-1.673,7.386,13.8-7.336a5.736,5.736,0,0,1,7.757,2.371l1.857,3.493L40.142,84.689,38.285,81.2A5.736,5.736,0,0,1,40.657,73.439Zm2.381,18.447,7.9,19.882,5.261-2.8L49.985,96.882l5.1-2.62,6.172,12.016L80.482,96.057,68.414,78.393Z",
    transform: "translate(-11.212 -3.947)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepcleaning);
export default __webpack_public_path__ + "static/media/deepcleaning.37ee54eed61bf7706d4547615e300b17.svg";
export { ForwardRef as ReactComponent };